import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
  <Container>
    <Row>
      <Col md={8} className="home-about-description">
        <h1 style={{ fontSize: "2.6em" }}>
          LET ME <span className="purple"> INTRODUCE </span> MYSELF
        </h1>
        <p className="home-about-body">
          Hi there! I'm a recent graduate in Information Technology from Priyadarshini Bhagwati College of Engineering , and I'm passionate about web development. 🚀
          <br />
          <br />
          My skill set includes NodeJS, JavaScript, ReactJS, MongoDB. I love building new and innovative web technologies and products.
          <br />
          <br />
          I'm particularly interested in the field of <span className="purple"> MERN STACK DEVELOPER </span> and enjoy exploring its applications.
          <br />
          <br />
          When it comes to developing, I'm fluent in classics like <i><b className="purple">NodeJS, ExpressJS, ReactJS, MongoDB, HTML And CSS</b></i>.
           
        </p>
      </Col>
      <Col md={4} className="myAvtar">
        <Tilt>
          <img src={myImg} className="img-fluid" alt="avatar" />
        </Tilt>
      </Col>
    </Row>
    <Row>
      <Col md={12} className="home-about-social">
        <h1>FIND ME ON</h1>
        <p>
          Feel free to <span className="purple">connect</span> with me on social media!
        </p>
        <ul className="home-about-social-links">
          <li className="social-icons">
            <a
              href="https://github.com/ritesh7397"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <AiFillGithub />
            </a>
          </li>
         
          <li className="social-icons">
            <a
              href="https://www.linkedin.com/in/ritesh-nagrikar-b97942201"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <FaLinkedinIn />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="https://www.instagram.com/riteshnagrikar"
              target="_blank"
              rel="noreferrer"
              className="icon-colour home-social-icons"
            >
              <AiFillInstagram />
            </a>
          </li>
        </ul>
      </Col>
    </Row>
  </Container>
</Container>

  );
}
export default Home2;
